/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Move all rows with expired courses to the bottom of the table
 * @author     Anna Morawe <anna.morawe@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

const sortLicenseTakers = () => {

        let _oLicenseTakersList = document.querySelectorAll('.js-expiredcourses');

        function sortLicense() {
            let _oTableBody = document.querySelectorAll('.js-expiredcourses > tbody');

            for (let i = 0; i < _oTableBody.length; i++) {
                let _oTableRows             = _oTableBody[i].getElementsByTagName('tr')[0];
                let _oTableRowsExpired      = _oTableBody[i].querySelectorAll('.is--expired');
                let _oTableBodyParent       = _oTableRows.parentElement;
                let _aSlicedRows            = Array.prototype.slice.call( _oTableRowsExpired, 0, 4);

                while (_aSlicedRows.length > 0) {
                    _oTableBodyParent.appendChild(_aSlicedRows.shift());
                }
            }
        }

        if(_oLicenseTakersList) {
            document.addEventListener('DOMContentLoaded', sortLicense);
        }

    };

sortLicenseTakers();
